/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppActivityRouteImport } from './routes/_app/activity'
import { Route as AppDeploymentsRouteImport } from './routes/_app/deployments'
import { Route as AppMembersRouteImport } from './routes/_app/members'
import { Route as AppTrashRouteImport } from './routes/_app/trash'
import { Route as AppPPageIdRouteImport } from './routes/_app/p/$pageId'
import { Route as AppCBoardIdCardIdRouteImport } from './routes/_app/c/$boardId.$cardId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppActivityRoute = AppActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppRoute,
} as any)
const AppDeploymentsRoute = AppDeploymentsRouteImport.update({
  id: '/deployments',
  path: '/deployments',
  getParentRoute: () => AppRoute,
} as any)
const AppMembersRoute = AppMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppRoute,
} as any)
const AppTrashRoute = AppTrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => AppRoute,
} as any)
const AppPPageIdRoute = AppPPageIdRouteImport.update({
  id: '/p/$pageId',
  path: '/p/$pageId',
  getParentRoute: () => AppRoute,
} as any)
const AppCBoardIdCardIdRoute = AppCBoardIdCardIdRouteImport.update({
  id: '/c/$boardId/$cardId',
  path: '/c/$boardId/$cardId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/activity': typeof AppActivityRoute
  '/deployments': typeof AppDeploymentsRoute
  '/members': typeof AppMembersRoute
  '/trash': typeof AppTrashRoute
  '/p/$pageId': typeof AppPPageIdRoute
  '/c/$boardId/$cardId': typeof AppCBoardIdCardIdRoute
}
export interface FileRoutesByTo {
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/activity': typeof AppActivityRoute
  '/deployments': typeof AppDeploymentsRoute
  '/members': typeof AppMembersRoute
  '/trash': typeof AppTrashRoute
  '/': typeof AppIndexRoute
  '/p/$pageId': typeof AppPPageIdRoute
  '/c/$boardId/$cardId': typeof AppCBoardIdCardIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/_app/activity': typeof AppActivityRoute
  '/_app/deployments': typeof AppDeploymentsRoute
  '/_app/members': typeof AppMembersRoute
  '/_app/trash': typeof AppTrashRoute
  '/_app/': typeof AppIndexRoute
  '/_app/p/$pageId': typeof AppPPageIdRoute
  '/_app/c/$boardId/$cardId': typeof AppCBoardIdCardIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/change-password'
    | '/login'
    | '/activity'
    | '/deployments'
    | '/members'
    | '/trash'
    | '/p/$pageId'
    | '/c/$boardId/$cardId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/change-password'
    | '/login'
    | '/activity'
    | '/deployments'
    | '/members'
    | '/trash'
    | '/'
    | '/p/$pageId'
    | '/c/$boardId/$cardId'
  id:
    | '__root__'
    | '/_app'
    | '/change-password'
    | '/login'
    | '/_app/activity'
    | '/_app/deployments'
    | '/_app/members'
    | '/_app/trash'
    | '/_app/'
    | '/_app/p/$pageId'
    | '/_app/c/$boardId/$cardId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/activity': {
      id: '/_app/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AppActivityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/deployments': {
      id: '/_app/deployments'
      path: '/deployments'
      fullPath: '/deployments'
      preLoaderRoute: typeof AppDeploymentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/members': {
      id: '/_app/members'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof AppMembersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trash': {
      id: '/_app/trash'
      path: '/trash'
      fullPath: '/trash'
      preLoaderRoute: typeof AppTrashRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/p/$pageId': {
      id: '/_app/p/$pageId'
      path: '/p/$pageId'
      fullPath: '/p/$pageId'
      preLoaderRoute: typeof AppPPageIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/c/$boardId/$cardId': {
      id: '/_app/c/$boardId/$cardId'
      path: '/c/$boardId/$cardId'
      fullPath: '/c/$boardId/$cardId'
      preLoaderRoute: typeof AppCBoardIdCardIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppActivityRoute: typeof AppActivityRoute
  AppDeploymentsRoute: typeof AppDeploymentsRoute
  AppMembersRoute: typeof AppMembersRoute
  AppTrashRoute: typeof AppTrashRoute
  AppIndexRoute: typeof AppIndexRoute
  AppPPageIdRoute: typeof AppPPageIdRoute
  AppCBoardIdCardIdRoute: typeof AppCBoardIdCardIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppActivityRoute: AppActivityRoute,
  AppDeploymentsRoute: AppDeploymentsRoute,
  AppMembersRoute: AppMembersRoute,
  AppTrashRoute: AppTrashRoute,
  AppIndexRoute: AppIndexRoute,
  AppPPageIdRoute: AppPPageIdRoute,
  AppCBoardIdCardIdRoute: AppCBoardIdCardIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
